import { render, staticRenderFns } from "./ImageModal.vue?vue&type=template&id=c602116a&lang=pug"
import script from "./ImageModal.vue?vue&type=script&lang=ts"
export * from "./ImageModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports